import React from 'react';

// Pill toggles above a piano roll. Visually these match the live demo's
// instrument buttons, but the live demo builds its buttons as raw DOM and
// drives them with injected CSS; here the visible set is ordinary React state.
const TrackToggles = ({ groups, visible, onToggle, onSetAll }) => {
  if (!groups || groups.length === 0) return null;

  const allVisible = groups.every((g) => visible[g.key]);
  const noneVisible = groups.every((g) => !visible[g.key]);

  return (
    <div className="roll-toggles">
      <span className="roll-toggles-label">Show</span>

      <button
        type="button"
        className={`roll-toggle-btn roll-toggle-all ${allVisible ? '' : 'subdued'}`}
        onClick={() => onSetAll(true)}
      >
        All
      </button>

      {groups.map((g) => {
        const isOn = !!visible[g.key];
        return (
          <button
            key={g.key}
            type="button"
            className={`roll-toggle-btn ${isOn ? 'active' : ''}`}
            style={isOn ? { backgroundColor: g.color, borderColor: g.color } : { '--roll-toggle-color': g.color }}
            onClick={() => onToggle(g.key)}
            data-tooltip={g.title || g.label}
            aria-pressed={isOn}
          >
            {g.label}
          </button>
        );
      })}

      <button
        type="button"
        className="roll-toggle-btn roll-toggle-empty"
        onClick={() => onSetAll(false)}
        disabled={noneVisible}
      >
        Clear
      </button>
    </div>
  );
};

export default TrackToggles;
